module.exports = __webpack_public_path__ + "d07eb0bd55a8f58985e3742020593e04.svg";